var map = {
	"./1024": 158,
	"./1024.png": 158,
	"./512": 159,
	"./512.png": 159,
	"./Pays-black-logo": 160,
	"./Pays-black-logo.svg": 160,
	"./activated": 161,
	"./activated.png": 161,
	"./basic_logos/bargraph": 162,
	"./basic_logos/bargraph.png": 162,
	"./basic_logos/bargraph1": 163,
	"./basic_logos/bargraph1.png": 163,
	"./basic_logos/bargraph2": 164,
	"./basic_logos/bargraph2.png": 164,
	"./basic_logos/calendar": 165,
	"./basic_logos/calendar.svg": 165,
	"./basic_logos/chart": 166,
	"./basic_logos/chart.png": 166,
	"./basic_logos/clone": 167,
	"./basic_logos/clone.svg": 167,
	"./basic_logos/close": 168,
	"./basic_logos/close-blue": 169,
	"./basic_logos/close-blue.svg": 169,
	"./basic_logos/close.svg": 168,
	"./basic_logos/customer_receipt_logo": 170,
	"./basic_logos/customer_receipt_logo.png": 170,
	"./basic_logos/delete": 171,
	"./basic_logos/delete-orange": 172,
	"./basic_logos/delete-orange.svg": 172,
	"./basic_logos/delete.svg": 171,
	"./basic_logos/diamond": 173,
	"./basic_logos/diamond.png": 173,
	"./basic_logos/dollar": 174,
	"./basic_logos/dollar.png": 174,
	"./basic_logos/download": 175,
	"./basic_logos/download-blue": 176,
	"./basic_logos/download-blue.svg": 176,
	"./basic_logos/download-rounded": 177,
	"./basic_logos/download-rounded.svg": 177,
	"./basic_logos/download.svg": 175,
	"./basic_logos/edit": 178,
	"./basic_logos/edit-orange": 179,
	"./basic_logos/edit-orange.svg": 179,
	"./basic_logos/edit.svg": 178,
	"./basic_logos/export": 180,
	"./basic_logos/export.svg": 180,
	"./basic_logos/file-icon": 181,
	"./basic_logos/file-icon.svg": 181,
	"./basic_logos/loader": 182,
	"./basic_logos/loader.gif": 182,
	"./basic_logos/plus": 183,
	"./basic_logos/plus.svg": 183,
	"./basic_logos/qr_demo_image": 184,
	"./basic_logos/qr_demo_image.svg": 184,
	"./basic_logos/remove": 185,
	"./basic_logos/remove.png": 185,
	"./basic_logos/setting": 186,
	"./basic_logos/setting.svg": 186,
	"./basic_logos/setting_kds": 187,
	"./basic_logos/setting_kds.svg": 187,
	"./basic_logos/snack": 188,
	"./basic_logos/snack.svg": 188,
	"./basic_logos/user": 189,
	"./basic_logos/user.svg": 189,
	"./cart": 190,
	"./cart.png": 190,
	"./check1": 191,
	"./check1.svg": 191,
	"./check2": 192,
	"./check2.svg": 192,
	"./circle": 193,
	"./circle.png": 193,
	"./completed": 194,
	"./completed.png": 194,
	"./dashboard_icons/cash_discount": 195,
	"./dashboard_icons/cash_discount.svg": 195,
	"./dashboard_icons/chart4": 196,
	"./dashboard_icons/chart4.svg": 196,
	"./dashboard_icons/gross_sale": 197,
	"./dashboard_icons/gross_sale.svg": 197,
	"./dashboard_icons/ic_profit": 198,
	"./dashboard_icons/ic_profit.svg": 198,
	"./dashboard_icons/ic_transactions": 199,
	"./dashboard_icons/ic_transactions.svg": 199,
	"./dashboard_icons/refund": 200,
	"./dashboard_icons/refund.svg": 200,
	"./dashboard_icons/reward": 201,
	"./dashboard_icons/reward.svg": 201,
	"./dashboard_icons/service_charge": 202,
	"./dashboard_icons/service_charge.svg": 202,
	"./dashboard_icons/tax": 203,
	"./dashboard_icons/tax.svg": 203,
	"./dashboard_icons/tender": 204,
	"./dashboard_icons/tender.svg": 204,
	"./dashboard_icons/tips": 205,
	"./dashboard_icons/tips.svg": 205,
	"./dashboard_icons/user": 206,
	"./dashboard_icons/user.svg": 206,
	"./favicon": 207,
	"./favicon.jpeg": 207,
	"./floor_plan/chair": 208,
	"./floor_plan/chair.png": 208,
	"./floor_plan/chair_1": 209,
	"./floor_plan/chair_1.png": 209,
	"./floor_plan/table": 142,
	"./floor_plan/table.png": 142,
	"./floor_plan/table.svg": 407,
	"./floor_plan/table_1": 210,
	"./floor_plan/table_1.svg": 210,
	"./gift-card": 211,
	"./gift-card.png": 211,
	"./header_icons/chat": 212,
	"./header_icons/chat.svg": 212,
	"./header_icons/file": 213,
	"./header_icons/file.svg": 213,
	"./header_icons/notification": 214,
	"./header_icons/notification.svg": 214,
	"./header_icons/question": 215,
	"./header_icons/question.svg": 215,
	"./header_icons/search": 216,
	"./header_icons/search.svg": 216,
	"./home/expand": 217,
	"./home/expand.svg": 217,
	"./home/ic_comment": 218,
	"./home/ic_comment.svg": 218,
	"./home/ic_delete": 219,
	"./home/ic_delete.svg": 219,
	"./home/ic_duplicate": 220,
	"./home/ic_duplicate.svg": 220,
	"./home/ic_edit": 221,
	"./home/ic_edit.svg": 221,
	"./home/ic_email": 222,
	"./home/ic_email.svg": 222,
	"./home/ic_events": 223,
	"./home/ic_events.svg": 223,
	"./home/ic_image": 224,
	"./home/ic_image.png": 224,
	"./home/ic_image@2x": 225,
	"./home/ic_image@2x.png": 225,
	"./home/ic_meet": 226,
	"./home/ic_meet.svg": 226,
	"./home/ic_note": 227,
	"./home/ic_note.svg": 227,
	"./home/ic_profile_pic": 228,
	"./home/ic_profile_pic.svg": 228,
	"./home/ic_resend_email": 229,
	"./home/ic_resend_email.svg": 229,
	"./home/ic_times": 230,
	"./home/ic_times.svg": 230,
	"./home/ic_view": 231,
	"./home/ic_view.svg": 231,
	"./home/permission": 232,
	"./home/permission.svg": 232,
	"./home/profile_placeholder": 233,
	"./home/profile_placeholder.svg": 233,
	"./homes/ASingleMenu": 234,
	"./homes/ASingleMenu.png": 234,
	"./homes/Abettercheckoutexperience": 235,
	"./homes/Abettercheckoutexperience.png": 235,
	"./homes/AccessRights": 236,
	"./homes/AccessRights.png": 236,
	"./homes/AddEmployeestoYourTeam": 237,
	"./homes/AddEmployeestoYourTeam.png": 237,
	"./homes/AddnewcustomersdirectlyfromBOLDPOS": 238,
	"./homes/AddnewcustomersdirectlyfromBOLDPOS.png": 238,
	"./homes/Backofhouse2x": 239,
	"./homes/Backofhouse2x.png": 239,
	"./homes/BundleItems": 240,
	"./homes/BundleItems.png": 240,
	"./homes/Call": 241,
	"./homes/Call.svg": 241,
	"./homes/CashDiscount": 242,
	"./homes/CashDiscount.png": 242,
	"./homes/Cloud-based": 243,
	"./homes/Cloud-based-16": 244,
	"./homes/Cloud-based-16.png": 244,
	"./homes/Cloud-based.png": 243,
	"./homes/Cloud2x": 245,
	"./homes/Cloud2x.png": 245,
	"./homes/Color-CodedDisplay": 246,
	"./homes/Color-CodedDisplay.png": 246,
	"./homes/CreateCustomerprofiles": 247,
	"./homes/CreateCustomerprofiles.png": 247,
	"./homes/CustomizeOrderingHours": 248,
	"./homes/CustomizeOrderingHours.png": 248,
	"./homes/Customize_Ordering_Hours": 249,
	"./homes/Customize_Ordering_Hours.png": 249,
	"./homes/DAVOSalesTax": 250,
	"./homes/DAVOSalesTax.png": 250,
	"./homes/DineIn": 251,
	"./homes/DineIn.png": 251,
	"./homes/EasySplit-MergeChecks": 252,
	"./homes/EasySplit-MergeChecks.png": 252,
	"./homes/Exportyourlisttoyouremailmarketingtool": 253,
	"./homes/Exportyourlisttoyouremailmarketingtool.png": 253,
	"./homes/FinalHomeBanner": 143,
	"./homes/FinalHomeBanner.png": 143,
	"./homes/FinalHomeBanner.svg": 408,
	"./homes/GoMobilewithTablesidePOSordering": 254,
	"./homes/GoMobilewithTablesidePOSordering.png": 254,
	"./homes/Group2_150": 255,
	"./homes/Group2_150.png": 255,
	"./homes/Group94": 256,
	"./homes/Group94.png": 256,
	"./homes/ImportyourcustomerlistintoBOLDPOS": 257,
	"./homes/ImportyourcustomerlistintoBOLDPOS.png": 257,
	"./homes/InbuildThemes": 258,
	"./homes/InbuildThemes.png": 258,
	"./homes/Inbuild_Themes": 259,
	"./homes/Inbuild_Themes.png": 259,
	"./homes/Inbuild_Themes@2x": 260,
	"./homes/Inbuild_Themes@2x.png": 260,
	"./homes/Info": 144,
	"./homes/Info.png": 144,
	"./homes/Info.svg": 409,
	"./homes/IngridientManagement": 261,
	"./homes/IngridientManagement.png": 261,
	"./homes/IntelligentReporting": 262,
	"./homes/IntelligentReporting.png": 262,
	"./homes/Itemimport": 263,
	"./homes/Itemimport.png": 263,
	"./homes/Itemmodifiers": 264,
	"./homes/Itemmodifiers.png": 264,
	"./homes/KitchenPrinters": 265,
	"./homes/KitchenPrinters.png": 265,
	"./homes/Labelprinting": 266,
	"./homes/Labelprinting.png": 266,
	"./homes/MailChimp": 267,
	"./homes/MailChimp.png": 267,
	"./homes/MobileResponsiveSite": 268,
	"./homes/MobileResponsiveSite.png": 268,
	"./homes/Mobile_Responsive_Site": 269,
	"./homes/Mobile_Responsive_Site.png": 269,
	"./homes/Mobile_Responsive_Site@2x": 270,
	"./homes/Mobile_Responsive_Site@2x.png": 270,
	"./homes/Multipleproductvariants": 271,
	"./homes/Multipleproductvariants.png": 271,
	"./homes/OpenOrders": 272,
	"./homes/OpenOrders.png": 272,
	"./homes/OrderHistoryReturns": 273,
	"./homes/OrderHistoryReturns.png": 273,
	"./homes/OrderStock": 274,
	"./homes/OrderStock.png": 274,
	"./homes/PayrollSimplified": 275,
	"./homes/PayrollSimplified.png": 275,
	"./homes/QuickBooksOnline": 276,
	"./homes/QuickBooksOnline.png": 276,
	"./homes/Real-timeOrderChanges": 277,
	"./homes/Real-timeOrderChanges.png": 277,
	"./homes/ReservationandWaitlistManagement": 278,
	"./homes/ReservationandWaitlistManagement.png": 278,
	"./homes/SalesbyEmployees": 279,
	"./homes/SalesbyEmployees.png": 279,
	"./homes/Services": 280,
	"./homes/Services.png": 280,
	"./homes/SetPermissionsandRoles": 281,
	"./homes/SetPermissionsandRoles.png": 281,
	"./homes/StockNotifications": 282,
	"./homes/StockNotifications.png": 282,
	"./homes/Stockadjustments": 283,
	"./homes/Stockadjustments.png": 283,
	"./homes/TableManagement": 284,
	"./homes/TableManagement.png": 284,
	"./homes/TakeOut": 285,
	"./homes/TakeOut.png": 285,
	"./homes/Timeclock": 286,
	"./homes/Timeclock.png": 286,
	"./homes/TipPooling": 287,
	"./homes/TipPooling.png": 287,
	"./homes/TrackCookingTimes": 288,
	"./homes/TrackCookingTimes.png": 288,
	"./homes/TrackOrderCompletion": 289,
	"./homes/TrackOrderCompletion.png": 289,
	"./homes/Transferorders": 290,
	"./homes/Transferorders.png": 290,
	"./homes/UnitCostMargins": 291,
	"./homes/UnitCostMargins.png": 291,
	"./homes/Untitled-5": 292,
	"./homes/Untitled-5.svg": 292,
	"./homes/Vendorpurchaseorders": 293,
	"./homes/Vendorpurchaseorders.png": 293,
	"./homes/VisualTableLayouts": 294,
	"./homes/VisualTableLayouts.png": 294,
	"./homes/Whatwillmyguestssee": 295,
	"./homes/Whatwillmyguestssee.png": 295,
	"./homes/android_pos2x": 296,
	"./homes/android_pos2x.png": 296,
	"./homes/arrow": 297,
	"./homes/arrow-2": 298,
	"./homes/arrow-2.svg": 298,
	"./homes/arrow-3": 299,
	"./homes/arrow-3.svg": 299,
	"./homes/arrow.png": 297,
	"./homes/arrow_150": 300,
	"./homes/arrow_150.png": 300,
	"./homes/cash_mgt2x": 301,
	"./homes/cash_mgt2x.png": 301,
	"./homes/contactless_payment": 302,
	"./homes/contactless_payment.png": 302,
	"./homes/customer_receipt2x": 303,
	"./homes/customer_receipt2x.png": 303,
	"./homes/dashboard_analytics": 304,
	"./homes/dashboard_analytics.svg": 304,
	"./homes/discount2x": 305,
	"./homes/discount2x.png": 305,
	"./homes/fast_staff2x": 306,
	"./homes/fast_staff2x.png": 306,
	"./homes/gift_card": 307,
	"./homes/gift_card.svg": 307,
	"./homes/intutive_design2x": 308,
	"./homes/intutive_design2x.png": 308,
	"./homes/line_items2x": 309,
	"./homes/line_items2x.png": 309,
	"./homes/location": 310,
	"./homes/location.svg": 310,
	"./homes/mail": 311,
	"./homes/mail.svg": 311,
	"./homes/marketing": 312,
	"./homes/marketing.svg": 312,
	"./homes/multiple_locations2x": 313,
	"./homes/multiple_locations2x.png": 313,
	"./homes/online_ordering": 314,
	"./homes/online_ordering.png": 314,
	"./homes/pos-fb": 315,
	"./homes/pos-fb.png": 315,
	"./homes/pos-linkedin": 316,
	"./homes/pos-linkedin.png": 316,
	"./homes/pos-twitter": 317,
	"./homes/pos-twitter.png": 317,
	"./homes/product_customer_search": 318,
	"./homes/product_customer_search.png": 318,
	"./homes/qr_code_ordering2x": 319,
	"./homes/qr_code_ordering2x.png": 319,
	"./homes/quick_service": 320,
	"./homes/quick_service.png": 320,
	"./homes/refunds_returns2x": 321,
	"./homes/refunds_returns2x.png": 321,
	"./homes/restaurant": 145,
	"./homes/restaurant.png": 145,
	"./homes/restaurant.svg": 410,
	"./homes/retail": 322,
	"./homes/retail.png": 322,
	"./homes/retail2x": 323,
	"./homes/retail2x.png": 323,
	"./homes/retail_pos": 324,
	"./homes/retail_pos.svg": 324,
	"./homes/service": 325,
	"./homes/service.png": 325,
	"./homes/set": 146,
	"./homes/set.png": 146,
	"./homes/set.svg": 411,
	"./homes/split_payment2x": 326,
	"./homes/split_payment2x.png": 326,
	"./homes/things-to-consider-food-app": 327,
	"./homes/things-to-consider-food-app.jpg": 327,
	"./homes/virtual_terminal": 328,
	"./homes/virtual_terminal.svg": 328,
	"./homes/work_offline2x": 329,
	"./homes/work_offline2x.png": 329,
	"./ic_fav": 330,
	"./ic_fav.svg": 330,
	"./ic_info": 331,
	"./ic_info.svg": 331,
	"./ic_pin": 332,
	"./ic_pin.png": 332,
	"./ic_radio": 333,
	"./ic_radio.png": 333,
	"./items/demo_image": 334,
	"./items/demo_image.jpg": 334,
	"./kds/KDS": 335,
	"./kds/KDS-2": 336,
	"./kds/KDS-2.svg": 336,
	"./kds/KDS.svg": 335,
	"./kds/KDS2": 337,
	"./kds/KDS2.svg": 337,
	"./kds/back": 338,
	"./kds/back.svg": 338,
	"./kds/cancelled_order": 339,
	"./kds/cancelled_order.png": 339,
	"./kds/check": 340,
	"./kds/check.svg": 340,
	"./kds/loading_spinner": 341,
	"./kds/loading_spinner.gif": 341,
	"./kds/refund": 342,
	"./kds/refund.jpeg": 342,
	"./kds/refunded": 343,
	"./kds/refunded.png": 343,
	"./kds/settings": 344,
	"./kds/settings.svg": 344,
	"./logo": 345,
	"./logo.svg": 345,
	"./online_ordering_settings_images/close": 147,
	"./online_ordering_settings_images/close.png": 147,
	"./online_ordering_settings_images/close.svg": 412,
	"./online_ordering_settings_images/full_banner": 346,
	"./online_ordering_settings_images/full_banner.png": 346,
	"./online_ordering_settings_images/half_banner": 347,
	"./online_ordering_settings_images/half_banner.png": 347,
	"./online_ordering_settings_images/theme1": 348,
	"./online_ordering_settings_images/theme1.png": 348,
	"./online_ordering_settings_images/theme2": 349,
	"./online_ordering_settings_images/theme2.png": 349,
	"./online_ordering_settings_images/theme3": 350,
	"./online_ordering_settings_images/theme3.png": 350,
	"./owl.video.play": 351,
	"./owl.video.play.png": 351,
	"./pays-white": 352,
	"./pays-white.jpeg": 352,
	"./pos": 353,
	"./pos-card": 354,
	"./pos-card.png": 354,
	"./pos.png": 353,
	"./printer/bluetooth": 355,
	"./printer/bluetooth.svg": 355,
	"./printer/lan": 356,
	"./printer/lan.svg": 356,
	"./printer/printer": 357,
	"./printer/printer.svg": 357,
	"./product_large_images/cashdrawer": 358,
	"./product_large_images/cashdrawer(600)": 359,
	"./product_large_images/cashdrawer(600).png": 359,
	"./product_large_images/cashdrawer.png": 358,
	"./product_large_images/paper": 360,
	"./product_large_images/paper(600)": 361,
	"./product_large_images/paper(600).png": 361,
	"./product_large_images/paper.png": 360,
	"./product_large_images/printer1": 362,
	"./product_large_images/printer1(600)": 363,
	"./product_large_images/printer1(600).png": 363,
	"./product_large_images/printer1.png": 362,
	"./product_large_images/printer2": 364,
	"./product_large_images/printer2(600)": 365,
	"./product_large_images/printer2(600).png": 365,
	"./product_large_images/printer2.png": 364,
	"./product_large_images/scan": 366,
	"./product_large_images/scan(600)": 367,
	"./product_large_images/scan(600).png": 367,
	"./product_large_images/scan.png": 366,
	"./product_large_images/stand": 368,
	"./product_large_images/stand(600)": 369,
	"./product_large_images/stand(600).png": 369,
	"./product_large_images/stand.png": 368,
	"./receipt/cancelled_order": 370,
	"./receipt/cancelled_order.png": 370,
	"./reports/filter": 371,
	"./reports/filter.svg": 371,
	"./reports/info": 372,
	"./reports/info.svg": 372,
	"./reports/info_white": 373,
	"./reports/info_white.svg": 373,
	"./search": 374,
	"./search.svg": 374,
	"./snack-logo": 375,
	"./snack-logo-black": 148,
	"./snack-logo-black.jpeg": 413,
	"./snack-logo-black.png": 148,
	"./snack-logo-black_new": 376,
	"./snack-logo-black_new.jpeg": 376,
	"./snack-logo-black_old": 377,
	"./snack-logo-black_old.svg": 377,
	"./snack-logo-black_old_old": 378,
	"./snack-logo-black_old_old.svg": 378,
	"./snack-logo.svg": 375,
	"./snack_logo": 379,
	"./snack_logo.svg": 379,
	"./success": 380,
	"./success.svg": 380,
	"./true-sign": 381,
	"./true-sign.png": 381
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 406;